import { useEffect, useRef, useState } from 'react';
import cls from 'classnames';
import { useAtomValue } from 'jotai';
import { $ToastAtom } from '~/atoms/simple-toast';

import './style.scss';

export default function SimpleToast(): JSX.Element {
  const { content, time } = useAtomValue($ToastAtom);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  const [show, setShow] = useState(false);

  const timer = useRef(0);
  useEffect(() => {
    if (!content || !time) {
      return;
    }

    setShow(true);
    const newTimer = window.setTimeout(() => {
      setShow(false);
    }, 2150);
    timer.current = newTimer;

    return () => window.clearTimeout(newTimer);
  }, [content, time]);

  return (
    <div className={cls('simple-toast', { show, hide: !show && hydrated })}>
      <p>{content || ''}</p>
    </div>
  );
}
